import { useState, useMemo, useCallback } from 'react';
import useSelector from '../../../hooks';

export default function useLocationServicePairs(displayedLocations) {
  const { results } = useSelector(state => ({
    service: state?.config.service,
  }));

  const [, setFetchedLocationCodes] = useState(new Set());

  const handleSlotsFetched = useCallback(locationCodes => {
    setFetchedLocationCodes(prevCodes => {
      const newCodes = new Set(prevCodes);
      locationCodes.forEach(code => newCodes.add(code));
      return newCodes;
    });
  }, []);

  const locationServicePairs = useMemo(() => {
    if (!displayedLocations || displayedLocations.length === 0)
      // waiting to fetch slots...
      return [];

    return displayedLocations.map(location => ({
      locationCode: location.code,
      serviceCode: location.service?.code || results?.service?.code,
      location: location,
    }));
  }, [displayedLocations, results]);

  return { locationServicePairs, handleSlotsFetched };
}
